import { createIconComponent } from '../../factory/create-icon-component';
export const ExpandIcon = createIconComponent(
  'ExpandIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 4L16.7373 9.73726C17.5293 10.5293 17.9253 10.9253 18.0737 11.382C18.2042 11.7837 18.2042 12.2163 18.0737 12.618C17.9253 13.0747 17.5293 13.4707 16.7373 14.2627L11 20"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 8L12 12L8 16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
